<template>
  <div
    class="box"
    :class="{'box--open': open}"
  >
    <slot />
  </div>
</template>

<script>
export default {
    name: 'Box',
    props: {
        open: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.box {
    background-color: $white;
    padding: 15px;
    box-shadow: 0 0 5px 2px rgba($black,.05);
    margin-bottom: 15px;

    &--open {
        box-shadow: 0 0 5px 2px rgba($black,.15);
    }
}
</style>
